import { Injectable } from '@angular/core';
import { SurveyService } from './survey.service';
import { Question } from 'survey-core';
import { AddQuestion } from '../../view-models/add-question';

@Injectable({
  providedIn: 'root'
})
export class QuestionsService {
  constructor(private surveyService: SurveyService) {
  }

  get licenseHeld() {
    return this.getQuestion('LicenseHeld');
  }

  get licenseType() {
    return this.getQuestion('LicType');
  }

  get officeSearch() {
    return this.getQuestion('Office-Search');
  }

  get nrdsSearch() {
    return this.getQuestion('NRDSSearch');
  }

  get nrds() {
    return this.getQuestion('NRDS');
  }

  get officeNRDS() {
    return this.getQuestion('OfficeNRDS');
  }

  get membershipType() {
    return this.getQuestion('MembershipType');
  }

  get licenseNumber() {
    return this.getQuestion('LicNumber');
  }

  get licenseName() {
    return this.getQuestion('LicName');
  }

  get licenseStatus() {
    return this.getQuestion('LicStatus');
  }

  get licenseState() {
    return this.getQuestion('LicState');
  }

  get licenseExpiry() {
    return this.getQuestion('LicExp');
  }

  get brokerLicenseNumber() {
    return this.getQuestion('BrkLic');
  }

  get brokerLicenseName() {
    return this.getQuestion('BrkName');
  }

  get brokerLicenseType() {
    return this.getQuestion('BrkLicType');
  }

  get corporateLicenseNumber() {
    return this.getQuestion('CorpLic');
  }

  get affiliatedLicense() {
    return this.getQuestion('AffiliatedLicense');
  }

  get corporateAffiliate() {
    return this.getQuestion('CorporateAffiliate');
  }

  get firstName() {
    return this.getQuestion('FirstName');
  }

  get lastName() {
    return this.getQuestion('LastName');
  }

  get emailAddress() {
    return this.getQuestion('emailaddress');
  }

  get officeSearchType() {
    return this.getQuestion('OfficeSearchType');
  }

  get paymentMethod() {
    return this.getQuestion('PaymentMethod');
  }

  get ecControlNumber() {
    return this.getQuestion('ECControlNumber');
  }

  get associationRequestID() {
    return this.getQuestion('AssociationRequestID');
  }

  get office() {
    return this.getQuestion('office');
  }

  get terms() {
    return this.getQuestion('terms');
  }

  getQuestion(questionName: string) {
    return this.surveyService.surveyModel.getQuestionByName(questionName);
  }

  addQuestion({
                name,
                type = 'text',
                value,
                isRequired,
                identifyingQuestion,
                includeInOutput,
                pageIndex = 1
              }: AddQuestion) {
    const questionToAdd = new Question(name);
    questionToAdd['type'] = type;
    questionToAdd.visible = false;
    questionToAdd.isRequired = !!isRequired;

    const currentPage = this.surveyService.surveyModel
      .getPage(pageIndex);

    currentPage.addQuestion(questionToAdd);

    const questionAdded = this.surveyService.surveyModel.getQuestionByName(name);
    questionAdded['identifyingQuestion'] = !!identifyingQuestion;
    questionAdded['includeInOutput'] = includeInOutput !== false;
    questionAdded.value = value || null;
  }

  setQuestionValueOrCreate(addQuestionObject: AddQuestion) {
    const question = this.getQuestion(addQuestionObject.name);
    if (question) {
      question.value = addQuestionObject.value;
    } else {
      this.addQuestion(addQuestionObject);
    }
  }
}
